import { Component } from "react";
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error,
        };
    }
    componentDidCatch(error, info) {
        this.props.onCatch?.(error, info);
    }
    render() {
        return this.state.error
            ? this.props.renderError(this.state.error)
            : this.props.children;
    }
}
